import { render, staticRenderFns } from "./MandaOficial.vue?vue&type=template&id=0578fe72&scoped=true"
import script from "./MandaOficial.vue?vue&type=script&lang=js"
export * from "./MandaOficial.vue?vue&type=script&lang=js"
import style0 from "./MandaOficial.vue?vue&type=style&index=0&id=0578fe72&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0578fe72",
  null
  
)

export default component.exports